import type { RefundInvoiceResponse } from '@vy/api-definition';
import { RefundInvoiceResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type RefundInvoicePayload = Parameters<ReturnType<typeof getPrivateApi>['refundInvoice']>[0];

export function useRefundInvoice(
  options?: UseMutationOptions<RefundInvoiceResponse, unknown, RefundInvoicePayload>,
) {
  return useMutation({
    mutationFn: async ({ invoiceId }) => {
      const api = getPrivateApi();

      const response = await api.refundInvoice({ invoiceId });

      return RefundInvoiceResponseSchema.parse(response);
    },
    ...options,
  });
}
